import React, { useContext } from 'react';
import { useGetSizeGuideQuery } from '../../redux-modules/service';
import Sidebar from '../../components/Sidebar/Sidebar';
import { Measure } from '../../components/ui/Icons';
import ProductContext from '../../contexts/ProductContext';

function SizeGuide({
  guide,
  type,
}: {
  guide: number,
  type: 'title' | 'content',
}) {
  const { data, isLoading, isFetching } = useGetSizeGuideQuery({
    guide,
  });

  if (isLoading || isFetching) {
    return Craft.t('product', 'Loading....');
  }

  if (type === 'title') {
    return data.title;
  }

  return <div dangerouslySetInnerHTML={{ __html: data.content }} />; // eslint-disable-line react/no-danger, max-len
}

export default function SizeGuideSidebar({
  guide,
}: {
  guide: number,
}) {
  const { translates } = useContext(ProductContext);
  const { products } = translates;

  return (
    <li className="border-b border-light-grey-1 last:border-none pb-4 last:pb-0 mb-4 last:mb-0">
      <Sidebar
        sidebarSizeClass="max-w-full sm:max-w-2xl"
        sidebarButtonClasses="inline-flex items-center gap-x-3 decoration-transparent hover:decoration-current underline transition-all"
        sidebarButtonContent={(
          <>
            <span className="flex justify-center items-center w-6 h-6 p-1">
              <Measure />
            </span>
            {Craft.t(products, 'Wat is mijn maat?')}
          </>
        )}
        sidebarTitle={(
          <SizeGuide
            guide={guide}
            type="title"
          />
        )}
        sidebarPanelContent={(
          <SizeGuide guide={guide} type="content" />
        )}
        closeButtonText={Craft.t(products, 'close')}
      />
    </li>
  );
}
